export default __webpack_public_path__ + "static/media/rehab.82ce237d.jpg";